"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const styles = (theme) => ({
    zeroStateContainer: {
        height: '100%',
        width: '100%',
        textAlign: 'center',
        verticalAlign: 'middle',
    },
    zeroStateContent: {
        display: 'flex',
        flexDirection: 'column',
        height: '60vh',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 18,
        color: theme.palette.text.secondary,
    },
    zeroStateTextHeadline: {
        marginBottom: 10,
        fontWeight: 500,
        margin: '10px 0 10px 0',
    },
    zeroStateTextBody: {
        textAlign: 'center',
        maxWidth: '80%',
    },
    accordionDetails: {
        borderTop: `1px solid ${theme.palette.border.light}`,
        padding: '20px 24px 7px 24px',
        display: 'flex',
    },
});
exports.styles = styles;
